// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"85":"772fcca6","544":"f99fdcef"}[chunkId] + ".chunk.css";
};